import React from 'react';
import { Grid } from '@mui/material';

import {
	DateField,
	ModuleSearchField,
	SearchSelectField,
	SimpleTextField,
	useSettings,
	Utils
} from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function ProjectsDetailsSectionInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();

	function autoUpdateDateTo(newStatus) {
		if ([3, 100].includes(newStatus?.prst_id) && !props.model.proj_d_to) {
			props.sendChange('proj_d_to', Utils.today());
		}
	}

	return (
		<>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* TITLE */}
				<SimpleTextField
					name="proj_title"
					label={t('DETAILS_PROJECTS_FIELD_TITLE')}
					value={props.model.proj_title}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 12 }}>
				{/* DATE FROM */}
				<DateField
					name="proj_d_from"
					label={t('DETAILS_PROJECTS_FIELD_DATE_FROM')}
					value={props.model.proj_d_from}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 12 }}>
				{/* DATE TO */}
				<DateField
					name="proj_d_to"
					label={t('DETAILS_PROJECTS_FIELD_DATE_TO')}
					value={props.model.proj_d_to}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* STATUS */}
				<SearchSelectField
					name="proj_prst_id"
					label={t('DETAILS_PROJECTS_FIELD_STATUS')}
					systable="projects_statuses"
					value={props.model.proj_prst_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					afterChange={autoUpdateDateTo}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* TYPE */}
				<SearchSelectField
					name="proj_prty_id"
					label={t('DETAILS_PROJECTS_FIELD_TYPE')}
					systable="projects_types"
					value={props.model.proj_prty_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* COMPANY */}
				<ModuleSearchField
					name="proj_comp_uid"
					label={t('DETAILS_PROJECTS_FIELD_COMPANY')}
					module="companies"
					uid={props.model.proj_comp_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* EXTERNAL CONTACT */}
				<ModuleSearchField
					name="proj_peop_uid"
					label={t('DETAILS_PROJECTS_FIELD_PERSON')}
					module="people"
					uid={props.model.proj_peop_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* ASSIGNED USER */}
				<ModuleSearchField
					name="proj_user_assigned_uid"
					label={t('DETAILS_PROJECTS_FIELD_ASSIGNED_USER')}
					module="users"
					filters={[{ filt_field: 'user_role_external', filt_clause: 'not_equal', filt_value: 1 }]}
					uid={props.model.proj_user_assigned_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* ASSIGNED USER 2 */}
				<ModuleSearchField
					name="proj_user_assigned_2_uid"
					label={t('DETAILS_PROJECTS_FIELD_ASSIGNED_USER_2')}
					module="users"
					filters={[{ filt_field: 'user_role_external', filt_clause: 'equals', filt_value: 1 }]}
					uid={props.model.proj_user_assigned_2_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
